import {wrapCall} from '../utils/serviceUtils';

import {api} from '../services';

// from https://github.com/mjrussell/redux-auth-wrapper/tree/master/examples/basic

// see also https://github.com/joshgeller/react-redux-jwt-auth-example/blob/master/src/actions/index.js

export function getUser() {
  return wrapCall(api.get('/svp/session/user'), 'get_user', {showErrorToaster: false});
}

export function updateUser(data) {
  return wrapCall(api.put('/svp/session/user', data), 'update_user');
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js